import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RolsExternal } from '../../core/entities/rolsexternal.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RolsExternalService {
    readonly BASE: any = PETICIONES.rolsexternal;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Obtiene todos los roles externos
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene un rol externo por su code
    */
    public findByCode(code: string): Observable<any> {
        let coderol: string = (code !== undefined && code !== null ? code + "" : "");
        return this.http.get(this.BASE.findByCode + "/" + coderol).pipe(delay(DELAY));
    }

    /**
    * @description
    * Guarda un rol externo en la base de datos
    */
    public postRolsExternal(rol: RolsExternal): Observable<any> {
        const json = JSON.stringify(rol);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postRolsExternal, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un rol external en la base de datos
    */
     public deleteRolsExternal(rol: RolsExternal): Observable<any> {
        let coderol: string = (rol.code !== undefined && rol.code !== null ? rol.code + "" : "");
        return this.http.get(this.BASE.deleteRolsExternal + "/" + coderol).pipe(delay(DELAY));
    }
}